<template>
  <div :class="className">
    <div class="sticky-select">
      <q-select
        label="Select company"
        v-model="selectedCompany"
        outlined
        label-color="grey-7"
        color="grey-7"
        :options="companies"
        :option-label="(company) => company.name"
        :option-value="(company) => company.id"
        dense
      >
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-italic text-grey">
              There is no options.
            </q-item-section>
          </q-item>
        </template>
      </q-select>
      <slot name="activator"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    className: String,
  },
  computed: {
    companies: {
      get() {
        return this.$store.state.company.companies;
      },
      set(val) {
        this.$store.commit("company/SET_USER_COMPANIES", val);
      },
    },
    selectedCompany: {
      get() {
        return this.$store.state.location.selectedCompany;
      },
      set(val) {
        this.$store.commit("location/SET_SELECTED_COMPANY", val);
      },
    },
  },
};
</script>
